import { call_api } from "@approck_web/app_socket.mts";
import {
    boolean_encode,
    type JsonValue,
    type Option,
    Option_decode,
    Option_encode,
    type Result,
    string_decode,
    string_encode,
    type Uuid,
    Uuid_decode,
    Uuid_encode,
} from "@artyp/lib.mts";

export namespace enter_email {
    // InnerAdt::NamedStruct: Input
    export type Input = { email: Option<string>; };

    // InnerAdt::NamedStruct: Input
    export function Input_encode(_value: Input): JsonValue {
        return {
            email: ((v) => {
                return Option_encode(v, string_encode);
            })(_value["email"]),
        };
    }

    // InnerAdt::Enum: Output
    export type Output = { Ok: { auth_password_uuid: Uuid; }; } | { "Disabled": true; } | {
        Error: { message: string; };
    };

    // Adt::Enum: Output
    export function Output_decode(_data: JsonValue): Result<Output, string> {
        if (typeof _data === "object" && _data !== null && !Array.isArray(_data)) {
            if (
                "Ok" in _data && typeof _data["Ok"] === "object" && _data["Ok"] !== null
                && !Array.isArray(_data["Ok"])
            ) {
                const _obj = _data["Ok"];
                const auth_password_uuid = Uuid_decode(_obj["auth_password_uuid"] ?? null);
                if ("Err" in auth_password_uuid) return auth_password_uuid;
                return { Ok: { "Ok": { "auth_password_uuid": auth_password_uuid.Ok } } };
            }
            if ("Disabled" in _data) return { Ok: { "Disabled": true } };
            if (
                "Error" in _data && typeof _data["Error"] === "object" && _data["Error"] !== null
                && !Array.isArray(_data["Error"])
            ) {
                const _obj = _data["Error"];
                const message = string_decode(_obj["message"] ?? null);
                if ("Err" in message) return message;
                return { Ok: { "Error": { "message": message.Ok } } };
            }
        }
        return { Err: "invalid variant" };
    }

    // api call function for `enter_email`
    export const api = {
        api: "::web::auth::login::enter_email",
        call: call,
        Input_encode: Input_encode,
        Output_decode: Output_decode,
    };

    export async function call(data: Input): Promise<Output> {
        const { promise } = call_api("::web::auth::login::enter_email", Input_encode(data));
        const output = await promise;
        const r = Output_decode(output);
        if ("Err" in r) throw r.Err;
        return r.Ok;
    }
}
export namespace enter_password {
    // InnerAdt::NamedStruct: Input
    export type Input = {
        auth_password_uuid: Uuid;
        password: Option<string>;
        remember_me: boolean;
        next_uri: Option<string>;
    };

    // InnerAdt::NamedStruct: Input
    export function Input_encode(_value: Input): JsonValue {
        return {
            auth_password_uuid: Uuid_encode(_value["auth_password_uuid"]),
            password: ((v) => {
                return Option_encode(v, string_encode);
            })(_value["password"]),
            remember_me: boolean_encode(_value["remember_me"]),
            next_uri: ((v) => {
                return Option_encode(v, string_encode);
            })(_value["next_uri"]),
        };
    }

    // InnerAdt::NamedStruct: InputErr
    export type InputErr = {
        auth_password_uuid: Option<string>;
        password: Option<string>;
        remember_me: Option<string>;
    };

    // Adt::NamedStruct: InputErr
    export function InputErr_decode(_data: JsonValue): Result<InputErr, string> {
        if (typeof _data === "object" && _data !== null && !Array.isArray(_data)) {
            const r_auth_password_uuid = ((v) => {
                return Option_decode(v, string_decode);
            })(_data["auth_password_uuid"] ?? null);
            if ("Err" in r_auth_password_uuid) return r_auth_password_uuid;
            const r_password = ((v) => {
                return Option_decode(v, string_decode);
            })(_data["password"] ?? null);
            if ("Err" in r_password) return r_password;
            const r_remember_me = ((v) => {
                return Option_decode(v, string_decode);
            })(_data["remember_me"] ?? null);
            if ("Err" in r_remember_me) return r_remember_me;
            return {
                Ok: {
                    "auth_password_uuid": r_auth_password_uuid.Ok,
                    "password": r_password.Ok,
                    "remember_me": r_remember_me.Ok,
                },
            };
        } else return { Err: "Named: wrong type: " + typeof _data };
    }

    // InnerAdt::Enum: Output
    export type Output = { Ok: { next_uri: string; }; } | { "Disabled": true; } | {
        InputErr: [InputErr];
    };

    // Adt::Enum: Output
    export function Output_decode(_data: JsonValue): Result<Output, string> {
        if (typeof _data === "object" && _data !== null && !Array.isArray(_data)) {
            if (
                "Ok" in _data && typeof _data["Ok"] === "object" && _data["Ok"] !== null
                && !Array.isArray(_data["Ok"])
            ) {
                const _obj = _data["Ok"];
                const next_uri = string_decode(_obj["next_uri"] ?? null);
                if ("Err" in next_uri) return next_uri;
                return { Ok: { "Ok": { "next_uri": next_uri.Ok } } };
            }
            if ("Disabled" in _data) return { Ok: { "Disabled": true } };
            if ("InputErr" in _data && Array.isArray(_data["InputErr"])) {
                const arr = _data["InputErr"];
                const v_0 = InputErr_decode(arr[0] ?? null);
                if ("Err" in v_0) return v_0;
                return { Ok: { "InputErr": [v_0.Ok] } };
            }
        }
        return { Err: "invalid variant" };
    }

    // api call function for `enter_password`
    export const api = {
        api: "::web::auth::login::enter_password",
        call: call,
        Input_encode: Input_encode,
        Output_decode: Output_decode,
    };

    export async function call(data: Input): Promise<Output> {
        const { promise } = call_api("::web::auth::login::enter_password", Input_encode(data));
        const output = await promise;
        const r = Output_decode(output);
        if ("Err" in r) throw r.Err;
        return r.Ok;
    }
}
